import { useEffect, useState } from 'react';
import { isTextKnob, KNOB_META } from './constants';

export function KnobInput({
  knobKey,
  value,
  disabled = false,
  onSave,
}: {
  knobKey: string;
  value: number;
  disabled?: boolean;
  onSave: (v: number) => Promise<void>;
}) {
  const known = KNOB_META[knobKey];
  const meta = isTextKnob(known) ? undefined : known;
  const [draft, setDraft] = useState(String(value));

  useEffect(() => setDraft(String(value)), [value]);

  const commit = () => {
    const n = Math.round(Number(draft));
    if (!Number.isFinite(n) || n === value || (meta && (n < meta.min || n > meta.max))) {
      setDraft(String(value));
      return;
    }
    onSave(n).catch(() => setDraft(String(value)));
  };

  return (
    <div className="atm-knob">
      <span className="kl">{meta?.label ?? knobKey}</span>
      <div className="kv">
        <input
          className="f-input small"
          type="number"
          min={meta?.min}
          max={meta?.max}
          value={draft}
          disabled={disabled}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
          }}
        />
        {meta?.unit && <span className="ku">{meta.unit}</span>}
      </div>
    </div>
  );
}
